export { PromoBanner, type PromoBannerProps } from './PromoBanner';
export { promoBannerSchema } from './schema';
